import { render, staticRenderFns } from "./ShiftWorkerCount.vue?vue&type=template&id=0ff25984&scoped=true&"
import script from "./ShiftWorkerCount.vue?vue&type=script&lang=js&"
export * from "./ShiftWorkerCount.vue?vue&type=script&lang=js&"
import style0 from "./ShiftWorkerCount.vue?vue&type=style&index=0&id=0ff25984&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ff25984",
  null
  
)

export default component.exports